import * as XLSX from 'xlsx';

/**
 * คอลัมน์สำหรับ Export Excel
 */
export interface ExportColumn {
  header: string;  // ชื่อหัวคอลัมน์ (ภาษาไทย)
  key: string;     // key ของ property ในข้อมูล
  width?: number;  // ความกว้างของคอลัมน์ (หน่วย: characters)
}

/**
 * ตัวเลือกสำหรับ Export Excel
 */
export interface ExportOptions {
  filename: string;         // ชื่อไฟล์ (ไม่รวม .xlsx)
  sheetName: string;        // ชื่อ sheet
  columns: ExportColumn[];  // คอลัมน์ที่ต้องการ export
  data: any[];              // ข้อมูลที่ต้องการ export
}

/**
 * Export ข้อมูลเป็นไฟล์ Excel (.xlsx)
 *
 * @param options - ตัวเลือกสำหรับการ export
 *
 * @example
 * ```typescript
 * exportToExcel({
 *   filename: 'companies-2025-10-09',
 *   sheetName: 'บริษัท',
 *   columns: [
 *     { header: 'ชื่อบริษัท', key: 'name', width: 30 },
 *     { header: 'จังหวัด', key: 'province', width: 20 },
 *   ],
 *   data: companies
 * });
 * ```
 */
export const exportToExcel = (options: ExportOptions): void => {
  const { filename, sheetName, columns, data } = options;

  // สร้าง header row
  const headers = columns.map(col => col.header);

  // แปลง data เป็น rows (เรียงตาม columns)
  const rows = data.map(item =>
    columns.map(col => {
      const value = item[col.key];
      // แปลง undefined/null เป็น empty string
      return value !== undefined && value !== null ? value : '';
    })
  );

  // รวม header + data
  const worksheetData = [headers, ...rows];

  // สร้าง worksheet จาก array of arrays
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  // กำหนดความกว้างของคอลัมน์
  worksheet['!cols'] = columns.map(col => ({
    wch: col.width || 20  // ค่าเริ่มต้น 20 characters
  }));

  // สร้าง workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  // Download file
  XLSX.writeFile(workbook, `${filename}.xlsx`);
};
